import { render } from "./UpdateStudent.vue?vue&type=template&id=741aa167&scoped=true"
import script from "./UpdateStudent.vue?vue&type=script&lang=js"
export * from "./UpdateStudent.vue?vue&type=script&lang=js"

import "./UpdateStudent.vue?vue&type=style&index=0&id=741aa167&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\四个火体育_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741aa167"]])

export default __exports__